import { 
  Smile, 
  XCircle, 
  HelpCircle, 
  CheckCircle2,
  Check,
  Home,
  User,
  Users,
  Settings,
  Search,
  Plus,
  Minus,
  Edit,
  Trash2,
  Download,
  Upload,
  Eye,
  EyeOff,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  ArrowLeft,
  Menu,
  X,
  Bell,
  Star,
  Heart,
  ShoppingCart,
  Package,
  BarChart,
  BarChart3,
  Calendar,
  Clock,
  Mail,
  Phone,
  MapPin,
  Filter,
  RefreshCw,
  Save,
  Copy,
  Share,
  ExternalLink,
  Info,
  AlertTriangle,
  CheckCircle,
  AlertCircle,
  // 新增 AdminNavigation 使用的圖示
  Store,
  TrendingUp,
  Building2,
  Crown,
  // 新增 Zap 圖示
  Zap,
  // 新增缺失的圖示
  FileText,
  QrCode,
  Loader2,
  ShoppingBag,
  Coins,
  ClipboardCheck,
  Building,
  // 新增 VendorScanView 需要的圖示
  Camera,
  CameraOff,
  Receipt,
  Keyboard,
  RotateCcw,
  // 新增 TransferDetailsStep 需要的圖示
  UserCheck,
  Wallet,
  Send,
  ArrowRight,
  MessageSquare,
  // 新增 PointsHistoryView 需要的圖示
  Trophy,
  ArrowDownCircle,
  ArrowUpCircle,
  MinusCircle,
  CreditCard,
  Gift,
  Award,
  TrendingDown,
  ArrowRightLeft,
  Target,
  PiggyBank,
  Banknote,
  // 新增營收報表需要的圖示
  Activity,
  Network,
  // 新增列印圖示
  Printer
} from "lucide-vue-next";

// Lucide Icons 映射表，支援 kebab-case 轉 PascalCase 查詢
export const LucideIcons = {
  // 基本圖示
  Smile,
  XCircle,
  CheckCircle2,
  Check,
  HelpCircle,
  
  // 導航圖示
  Home,
  User,
  Users,
  Settings,
  Search,
  Menu,
  X,
  
  // 動作圖示
  Plus,
  Minus,
  Edit,
  Trash2,
  Download,
  Upload,
  Eye,
  EyeOff,
  Save,
  Copy,
  Share,
  RefreshCw,
  
  // 方向圖示
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  ArrowLeft,
  
  // 通知與狀態
  Bell,
  Star,
  Heart,
  Info,
  AlertTriangle,
  CheckCircle,
  AlertCircle,
  
  // 商務圖示
  ShoppingCart,
  Package,
  BarChart,
  BarChart3,
  
  // 時間與聯絡
  Calendar,
  Clock,
  Mail,
  Phone,
  MapPin,
  
  // 其他功能
  Filter,
  ExternalLink,
  
  // 新增 AdminNavigation 使用的圖示
  Store,
  TrendingUp,
  Building2,
  Crown,
  
  // 新增其他圖示
  Zap,
  
  // 新增缺失的圖示
  FileText,
  QrCode,
  Loader2,
  ShoppingBag,
  Coins,
  ClipboardCheck,
  Building,
  
  // 新增 VendorScanView 需要的圖示
  Camera,
  CameraOff,
  Receipt,
  Keyboard,
  RotateCcw,
  
  // 新增 TransferDetailsStep 需要的圖示
  UserCheck,
  Wallet,
  Send,
  ArrowRight,
  MessageSquare,
  
  // 新增 PointsHistoryView 需要的圖示
  Trophy,
  ArrowDownCircle,
  ArrowUpCircle,
  MinusCircle,
  CreditCard,
  Gift,
  Award,
  TrendingDown,
  ArrowRightLeft,
  Target,
  PiggyBank,
  Banknote,
  
  // 新增營收報表需要的圖示
  Activity,
  Network,
  
  // 新增列印圖示
  Printer
};

// 預設圖示（當找不到指定圖示時使用）
export const DefaultLucideIcon = HelpCircle;
